import { useMutation } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { useState } from "react";
import { Button, ButtonVariant, Checkbox } from "shared/components";
import { EyeOff } from "untitledui-js-base";
import { ReportHeader } from "views/applications-id-report/components/ReportHeader";
import { PrintReady } from "views/applications-id-report/providers/PrintProvider";

interface ReportViewApprovalProps {
  reportDate: string | Date | undefined;
  verificationId: number;
  refetch: () => void;
  applicationId: number;
  applicantId: number;
}

export const ReportViewApproval = ({
  reportDate,
  verificationId,
  applicationId,
  applicantId,
  refetch
}: ReportViewApprovalProps) => {
  const [isApproved, setIsApproved] = useState<boolean>(false);

  const { mutate, isPending } = useMutation({
    mutationKey: ["APPROVE_CRIMINAL_REPORT", verificationId],
    mutationFn: () => {
      return instance.post(
        `portal/v1/applications/${applicationId}/applicants/${applicantId}/verifications/${verificationId}/approve`
      );
    },
    onSuccess: () => {
      refetch();
    }
  });

  return (
    <>
      <ReportHeader
        title="Criminal report"
        reportDate={reportDate}
        verificationId={verificationId}
        printDisabled={true}
      />

      <PrintReady verificationId={verificationId} />

      <div className="flex flex-col items-center w-full justify-center item">
        <div className="flex items-center justify-center w-[100px] h-[100px] rounded-full bg-[#1C1D2205] mt-7">
          <EyeOff className="stroke-content-400 w-10 h-10" />
        </div>

        <p className="text-content-500 font-bold mb-2 mt-6">
          Criminal report is hidden
        </p>
        <p className="text-content-300 text-sm font-medium max-w-sm text-center mb-6">
          Criminal report is hidden until you confirm that the applicant is
          conditionally approved
        </p>

        <div className="flex items-center gap-2 border-t border-alpha-40 pt-6">
          <div>
            <Checkbox
              checked={isApproved}
              onChange={() => setIsApproved((prev) => !prev)}
              className="!w-4 !h-4"
            />
          </div>
          <p>
            I conditionally approve this applicant on factors other than
            criminal background
          </p>
        </div>

        <Button
          loading={isPending}
          loadingText="Approving..."
          variant={ButtonVariant.PRIMARY}
          className="mt-4"
          disabled={!isApproved}
          onClick={() => mutate()}
        >
          Show report
        </Button>
      </div>
    </>
  );
};
